import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import tradetronWelcome from "./../../../Images/tradetronWelcome.png";
// import algotestbanner from "./../../../Images/algotest/algotest-banner.jpg";
import algotestbanner from "./../../../Images/algotest/TradeRadarNew.png";
import AlgoBulls from './../../../Images/tools/algo-trading/single-page/AlgoBulls.png'
import "./AlgoTestWelcome.css";
function AlgoTestWelcome(props) {
  const title = props.data.title; // Assuming props.data.title is a string
  const splitIndex = title.indexOf('strategies with target & stoploss') + 'strategies with target & stoploss'.length;
  
  // Splitting the title into two parts based on the splitIndex
  const firstPart = title.slice(0, splitIndex).trim();
  const secondPart = title.slice(splitIndex).trim();
  return (
    <>
      <section className="AlgoTestWelcome_section">
        <Container>
          <Row>
            <Col md={7}>
              <div>
                <h3> Automate your option trading <span className="text-blue">strategies with target & stoploss</span></h3>
              </div>
            </Col>
            <Col md={5}>
              <div className="AlgoTestWelcome_img pl-3">
                <img
                  className="img-fluid"
                  src={algotestbanner}
                  alt="AlgoBulls"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default AlgoTestWelcome;
